import React from 'react';
import Style from './index.module.scss';
import {Schema} from 'form-render/lib/type';
import FormRender, {useForm} from 'form-render';
import {Button, message, Skeleton, Spin} from 'antd';
import useRequestFn from '../../../../../../Utils/Hooks/useRequestFn';
import {
    getTenantLogin,
    saveTenantLogin,
    SaveTenantLoginProp,
} from '../../../service';
import {errorMessage} from '../../../../../../Utils/common';
import {FlexBox} from '../../../../../../Components/FlexBox';
import useRequest from 'Utils/Hooks/useRequest';
import {useDict} from '../../../dict';
import {Editor} from 'Components/Editor';
import {useNavigate} from 'react-router-dom';

interface Props {
    id: string;
    current: number;
    setCurrent: (v: number) => void;
}

const Index = ({id, current, setCurrent}: Props) => {
    const navigator = useNavigate();
    const dict = useDict();
    const form = useForm();
    const schema: Schema = {
        type: 'object',
        displayType: 'row',
        labelCol: 8,
        fieldCol: 11,
        properties: {
            manualLoginCheck: {
                title: '注册审核',
                type: 'string',
                widget: 'radio',
                props: {
                    options: dict.Switch.data,
                },
            },
            signInType: {
                title: '注册方式',
                type: 'string',
                widget: 'radio',
                props: {
                    options: dict.RegType.data,
                },
            },
            serviceAgreement: {
                title: '服务协议',
                type: 'string',
                widget: 'radio',
                props: {
                    options: dict.Switch.data,
                },
            },
            agreementContent: {
                title: '协议内容',
                type: 'string',
                widget: 'Editor',
                hidden: '{{ formData.serviceAgreement === "SWITCH10000102" }}',
            },
            privacyPolicy: {
                title: '隐私条款',
                type: 'string',
                widget: 'radio',
                props: {
                    options: dict.Switch.data,
                },
            },
            privacyPolicyContent: {
                title: '条款内容',
                type: 'string',
                widget: 'Editor',
                hidden: '{{ formData.privacyPolicy === "SWITCH10000102" }}',
            },
        },
    };

    const [save, {loading: saveLoading}] = useRequestFn(saveTenantLogin);
    async function onFinish(formData: SaveTenantLoginProp) {
        try {
            await save({
                ...formData,
                customerId: id,
            });
            message.success('保存成功');
            navigator('/tenant/list');
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    const [data, {loading: getLoading}] = useRequest(
        async () => {
            return getTenantLogin(id);
        },
        {},
        [id],
    );

    async function addStep(step: number) {
        form.validateFields().then(async res => {
            await onFinish(res);
            setCurrent(current + step);
        });
    }

    return (
        <div className={Style.root}>
            <Skeleton active loading={getLoading} paragraph={{rows: 10}}>
                <Spin spinning={saveLoading}>
                    <FormRender
                        initialValues={data}
                        form={form}
                        schema={schema}
                        onFinish={onFinish}
                        widgets={{Editor}}
                    />
                    <FlexBox justifyContent="center" gap="15px">
                        <Button onClick={() => addStep(-1)}>上一步</Button>
                        <Button type="primary" onClick={form.submit}>
                            保存
                        </Button>
                    </FlexBox>
                </Spin>
            </Skeleton>
        </div>
    );
};

export default Index;
